import { computed, ref, onMounted } from 'vue'
import { defineStore } from 'pinia'
import countries from '@utils/countries.js'
import { getItemLocalStorage, setToLocalStorage } from '@utils/helper.utils.js'
import { useI18n } from 'vue-i18n'

export const usei18nStore = defineStore('i18n', () => {
  const i18n = useI18n()

  // Move computed properties inside the store setup
  const countrySettings = countries[import.meta.env.VITE_INSTITUATION] || {}
  const defaultLocale = ref(getItemLocalStorage('locale') || 'en')

  const availableLocales = [
    { localeCode: 'en', language: 'English' },
    { localeCode: 'fr', language: 'French' },
  ]

  const codes = {
    en: 'en-US',
    fr: 'fr-FR',
  }

  const changeLocale = (locale) => {
    try {
      defaultLocale.value = locale
      i18n.locale.value = locale
      setToLocalStorage('locale', locale)
      setToLocalStorage('localeCode', `${codes[locale]}`)
    } catch (error) {
      return error
    }
  }

  const {
    calling_code: calling_code,
    currency,
    currencyIsoCode,
  } = countrySettings

  return {
    i18n,
    changeLocale,
    availableLocales,
    countrySettings,
    currency,
    calling_code,
    defaultLocale,
    currencyIsoCode,
  }
})

export default usei18nStore
